import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from 'moment'

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontWeight: 'normal',
    fontSize: "12px",
    lineHeight: "16px",
    color: "#141414",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
    minWidth: "80px"
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  },
  sectionTitle: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    color: "#0b1f82",
    fontSize: "14px",
    marginTop: "16px",
    marginBottom: "8px",
  },
  even: {
    background: "#F3F3F3",
  },
  odd: {
    background: "#FFFFFF",
  },
}));

function DictStatisticsTable(props) {
  const classes = useStyles();
  useTheme();

  const getClass = (rowIndex) => {
    if (rowIndex % 2 === 0) {
      return classes.even;
    }

    return classes.odd;
  };

  const getWindowValue = (counter, window) => {
    if (counter == null) {
      return "-";
    }
    if (counter[window] == null) {
      return "-";
    }

    return String(counter[window]);
  };

  const formatWatermark = (watermark) => {
    if (watermark == null) {
      return "-";
    }

    return moment(watermark).format('DD/MM/YYYY HH:mm');
  };

  const { dict_statistics } = props;

  const windowedRows = [];
  if (dict_statistics.fraud_markers_application_frauds != null) {
    windowedRows.push({ label: "Fraudes de aplicação", counter: dict_statistics.fraud_markers_application_frauds });
  }
  if (dict_statistics.fraud_markers_mule_accounts != null) {
    windowedRows.push({ label: "Contas laranja", counter: dict_statistics.fraud_markers_mule_accounts });
  }
  if (dict_statistics.fraud_markers_scammer_accounts != null) {
    windowedRows.push({ label: "Contas de golpista", counter: dict_statistics.fraud_markers_scammer_accounts });
  }
  if (dict_statistics.fraud_markers_other_frauds != null) {
    windowedRows.push({ label: "Outras fraudes", counter: dict_statistics.fraud_markers_other_frauds });
  }
  if (dict_statistics.fraud_markers_unknown_frauds != null) {
    windowedRows.push({ label: "Fraudes não especificadas", counter: dict_statistics.fraud_markers_unknown_frauds });
  }
  if (dict_statistics.fraud_markers_distinct_fraud_reporters != null) {
    windowedRows.push({ label: "Notificantes distintos de fraude", counter: dict_statistics.fraud_markers_distinct_fraud_reporters });
  }
  if (dict_statistics.fraud_markers_total_fraud_transaction_amount != null) {
    windowedRows.push({ label: "Valor total transacionado em fraudes", counter: dict_statistics.fraud_markers_total_fraud_transaction_amount });
  }
  if (dict_statistics.infraction_reports_rejected_reports != null) {
    windowedRows.push({ label: "Relatos de infração rejeitados", counter: dict_statistics.infraction_reports_rejected_reports });
  }
  if (dict_statistics.spi_settlements != null) {
    windowedRows.push({ label: "Liquidações no SPI", counter: dict_statistics.spi_settlements });
  }

  const rows = [];
  if (dict_statistics.total_number_of_infraction_reports != null) {
    rows.push({ label: "Total de marcações de fraude (60 meses)", value: String(dict_statistics.total_number_of_infraction_reports) });
  }
  if (dict_statistics.infraction_reports_open_reports != null) {
    rows.push({ label: "Relatos de infração em aberto", value: String(dict_statistics.infraction_reports_open_reports) });
  }
  if (dict_statistics.infraction_reports_open_reports_distinct_reporters != null) {
    rows.push({ label: "Notificantes distintos com relato em aberto", value: String(dict_statistics.infraction_reports_open_reports_distinct_reporters) });
  }
  if (dict_statistics.entries_registered_accounts != null) {
    rows.push({ label: "Contas registradas no DICT", value: String(dict_statistics.entries_registered_accounts) });
  }
  if (dict_statistics.fraud_markers_watermark != null) {
    rows.push({ label: "Marcações de fraude atualizadas até", value: formatWatermark(dict_statistics.fraud_markers_watermark) });
  }
  if (dict_statistics.infraction_reports_watermark != null) {
    rows.push({ label: "Relatos de infração atualizados até", value: formatWatermark(dict_statistics.infraction_reports_watermark) });
  }
  if (dict_statistics.entries_watermark != null) {
    rows.push({ label: "Contas registradas atualizadas até", value: formatWatermark(dict_statistics.entries_watermark) });
  }

  return (
    <div>
      {windowedRows.length === 0 ? null :
      <>
        <div className={classes.sectionTitle}>Contadores por janela</div>
        <Paper className={classes.tableStyle}>
          <Table style={{ padding: "8px" }}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHeader}>Indicador</TableCell>
                <TableCell className={classes.tableHeader}>90 dias</TableCell>
                <TableCell className={classes.tableHeader}>12 meses</TableCell>
                <TableCell className={classes.tableHeader}>60 meses</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {windowedRows.map((row, index) => (
                <TableRow
                  key={index}
                  className={getClass(index)}
                >
                  <TableCell style={{whiteSpace:"nowrap"}} className={classes.tableText}>
                    {row.label}
                  </TableCell>
                  <TableCell className={classes.tableText}>
                    {getWindowValue(row.counter, "d90")}
                  </TableCell>
                  <TableCell className={classes.tableText}>
                    {getWindowValue(row.counter, "m12")}
                  </TableCell>
                  <TableCell className={classes.tableText}>
                    {getWindowValue(row.counter, "m60")}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </>
      }
      {rows.length === 0 ? null :
      <>
        <div className={classes.sectionTitle}>Situação atual</div>
        <Paper className={classes.tableStyle}>
          <Table style={{ padding: "8px" }}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableHeader}>Campo</TableCell>
                <TableCell className={classes.tableHeader}>Valor</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, index) => (
                <TableRow
                  key={index}
                  className={getClass(index)}
                >
                  <TableCell style={{whiteSpace:"nowrap"}} className={classes.tableText}>
                    {row.label}
                  </TableCell>
                  <TableCell className={classes.tableText}>
                    {row.value}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Paper>
      </>
      }
    </div>
  );
}

export default DictStatisticsTable;
